export interface SettingsLink {
  to: string;
  label: string;
  /** `true` when the route must match exactly (the index page at `/settings`). */
  end?: boolean;
}

export interface SettingsGroup {
  name: string;
  links: SettingsLink[];
}

/** Settings navigation, grouped as note 03 §3.3 records. */
export const settingsGroups: SettingsGroup[] = [
  {
    name: "Account",
    links: [
      { to: "/settings", label: "Profile", end: true },
      { to: "/settings/preferences", label: "Preferences" },
      { to: "/settings/notifications", label: "Notifications" },
      { to: "/settings/api-and-access", label: "API and access" },
    ],
  },
  {
    name: "Workspace",
    links: [
      { to: "/settings/details", label: "Details" },
      { to: "/settings/authentication", label: "Authentication" },
      { to: "/settings/security", label: "Security" },
      { to: "/settings/features", label: "Features" },
      { to: "/settings/users", label: "Members" },
      { to: "/settings/groups", label: "Groups" },
      { to: "/settings/templates", label: "Templates" },
      { to: "/settings/api-keys", label: "API keys" },
      { to: "/settings/shares", label: "Shared links" },
      { to: "/settings/import", label: "Import" },
      { to: "/settings/export", label: "Export" },
    ],
  },
];
